
import XHeader from 'vux/src/components/x-header/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import {mapState,mapMutations} from 'vuex'
import { contractOrderDetail, deliveryOrderInfo } from '../service/getdata'
export default{
components:{
XHeader,
Toast
},
data(){
return{
msg: "",
show: false,
info: {},
type: "",
trade_type: ""
}
},
computed:{
...mapState(['token'])
},
created(){
this.type = this.$route.query.type
this.trade_type  = this.$route.query.trade_type
this.SETTOKEN()
this.getData()
},
methods:{
...mapMutations(['SETTOKEN']),
getData(){
var that = this
this.$Loading()



if(this.type=='1'){
contractOrderDetail({token: this.token, id: this.$route.query.id, trade_type: this.trade_type}).then(function(res){
var res = res.data;
that.$Loading.close()


if(res.status=='1'){
that.info = res.data[0]


}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}
}.bind(this),function(){
that.$Loading.close()
console.log("error")
})
}else{
deliveryOrderInfo({token: this.token, id: this.$route.query.id, trade_type: this.trade_type}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){
that.info = res.data[0]


}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}
}.bind(this),function(){
that.$Loading.close()
console.log("error")
})
}

},
timeChange(time) {
if(!time){
return '-'
}

if (typeof time === 'string' && time.includes('-')) {
return time;
}

var date = new Date(time*1000);
var Y = date.getFullYear() + '-';
var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
var D = date.getDate() <10 ? '0'+date.getDate() + ' ' : date.getDate()+' ';
var h = date.getHours() + ':';
var m = date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes() ;
var s = date.getSeconds();
return Y+M+D+h+m;
},
sendMsg(content) {
this.msg = content;
this.show = true;
},


},
watch:{

}
}



// WEBPACK FOOTER //
// ./src/pages/orderDetail.vue